import s from './index.module.css';
import MainChatPage from "@common/Chat/MainChatPage/MainChatPage";
import CreateChat from "@common/Chat/CreateChat/CreateChat";
import ChatView from "@common/Chat/components/ChatView/ChatView";
import {useEffect, useState} from "react";
import DefaultView from "@common/Chat/DefaultView/DefaultView";
import InChatView from "@common/Chat/InChatView/InChatView";
import ChatInfo from "@common/Chat/ChatInfo/ChatInfo";
import {chatApi} from "@/api";
import { Resizable } from 're-resizable';
import {checkHeight, checkMinWidth, checkWidth} from "@common/Chat/helpers";
import classNames from "classnames";
import {useAddAlert} from "@/hooks/useAddAlert";
import websocket from '@/utils/websocket';
import { useChatContext } from './ChatContext';
import { useSelector } from 'react-redux';

const pages = {
    default: DefaultView,
    main: MainChatPage,
    chat: ChatView,
    create: CreateChat,
    inChat: InChatView,
    info: ChatInfo,
}

const Component = ({page,setPage, chat = null, typeAction = 'create', setTypeAction, unReadChats, activeUsers, height, params, getActiveUsers}) => {
    const Component = pages[page]
    return (
        <>
            {Component && <Component
                setPage={setPage}
                height={height}
                chat={chat}
                page={page}
                setTypeAction={setTypeAction}
                typeAction={typeAction}
                unReadChats={unReadChats}
                activeUsers={activeUsers}
                params={params}
                getActiveUsers={getActiveUsers}
            />}
        </>
    )
}
const Chat = ({ chatState }) => {
    const chatContext = useChatContext()
    const isChatEnabled = useSelector(store => store.settings.isChatEnabled);
    
    const [updateComponent, setUpdateComponent] = useState(false)
    useEffect(()=>{
        
        const onScroll = (event) => {
            setUpdateComponent(!updateComponent)
        }
      
        window.addEventListener('resize', onScroll);
        
        return () => {
            window.removeEventListener('resize', onScroll);
        }

    }, [])
    
    const showAlert = useAddAlert()

    const { page, chat, typeAction, changePage, params } = chatState;
    const screenWidth = window.innerWidth;
    const widthChatFromLS = JSON.parse(localStorage.getItem('widthChat'));
    const [unReadChats, setUnReadChats] = useState([])
    const [activeUsers, setActiveUsers] = useState([])

    const minWidth = checkMinWidth(page, isChatEnabled == '1' ? unReadChats : [])
    const maxWidthChat = checkWidth(page, isChatEnabled == '1' ? unReadChats : [])
    const heightChat = checkHeight(page)

    const [width, setWidth] = useState(widthChatFromLS ? widthChatFromLS : minWidth)

    useEffect(() => {
        localStorage.setItem('widthChat', JSON.stringify(width))
    }, [width])

    const saveWidthSettings = (width) => {
        setWidth(width)
    }

    // Функция для подсчета непрочитанных сообщений поддержки
    const updateSupportUnreadCount = (unReadChats) => {
        if (!chatContext) return
        
        const supportUnreadCount = unReadChats?.filter(chat => chat.type === 'support')?.reduce((total, chat) => total + chat.count, 0)

        
        chatContext.setUnreadSupportMessagesCount(Number(supportUnreadCount ?? 0))
    }

    // Обновляем currentOpenChatId при изменении страницы или чата
    useEffect(() => {
        if (chatContext) {
            if (page === 'inChat' && chat) {
                chatContext.setCurrentOpenChatId(chat);
                console.log('Setting current open chat ID to:', chat);
            } else {
                chatContext.setCurrentOpenChatId(null);
                console.log('Clearing current open chat ID');
            }
        }
    }, [page, chat, chatContext]);

    const getActiveUsers = async () => {
        try {
            const res = await chatApi.getActiveUsers()
            if (res?.data) {
                if(res?.data?.noReadMessages){
                    setUnReadChats(res?.data?.noReadMessages)
                    updateSupportUnreadCount(res?.data?.noReadMessages)
                }

                if (page === 'default') {
                    res.data.notifications?.map(showNewMessageNotification)
                }
            }
            return res
        } catch (error) {
            console.error('Error fetching active users:', error)
            throw error
        }
    }

    useEffect(() => {
        getActiveUsers();

        websocket.subscribe('active_users', (data) => {
            if (data) {
                setActiveUsers(data?.activeUsers);
            }
        });

        websocket.subscribe('chat_notifications', (data) => {
            if (data) {
                if(data?.data?.data?.noReadMessages){
                        setUnReadChats(data?.data?.data?.noReadMessages ?? []);
                        updateSupportUnreadCount(data?.data?.data?.noReadMessages ?? []);

                        // if (page === 'default') {
                        //     data?.data?.data?.notifications?.forEach(showNewMessageNotification ?? []);
                        // }
                }
            }
        });
    }, []);

    const showNewMessageNotification = (newMessage) => {
        showAlert({
            title: newMessage.user,
            text: newMessage.message || '',
            files: newMessage.files,
            sound: true,
            onClick: () => {
                changePage('inChat', newMessage.chat_id)
            }
        })
    }

    return (
        <Resizable
            className={classNames( s.chats)}
            defaultSize={{
                width: width,
            }}
            minWidth={minWidth}
            maxWidth={ maxWidthChat}
            enable={{bottom:false, top: false, left: true, right: false}}
            minHeight={heightChat}
            maxHeight={heightChat}
            onResizeStop={(e, direction, ref, d) => {
                saveWidthSettings(width + d.width)
            }}
        >
            <Component
                page={page}
                height={heightChat}
                setPage={changePage}
                chat={chat}
                setTypeAction={chatState.setTypeAction}
                typeAction={typeAction}
                unReadChats={unReadChats}
                activeUsers={activeUsers}
                params={params}
                getActiveUsers={getActiveUsers}
            />
        </Resizable>
    )
}

export default Chat;